import * as Types from '../model/types';
import * as OpTypes from '../opTypes';
import * as Graph from '../graph';
import * as Op from '../ops';
import {constNode, constString} from '../consts';

// Hide for now, its showing up at the top of the suggestion list
// TODO: this should make use of opKinds TagGetterOp. We'll need
// TagGetterOp to accept a callback that can be used to apply a
// function to the returned tag.
export const opAssetArtifactVersion = Graph.makeOp({
  hidden: true,
  name: 'asset-artifactVersion',
  argTypes: {
    asset: Types.nullableOneOrMany(
      Types.union([Types.withFileTag('any', {type: 'file'})])
    ),
  },
  description: `Returns the ${Graph.docType('artifactVersion')} of the asset`,
  argDescriptions: {
    asset: 'The asset',
  },
  returnValueDescription: `The ${Graph.docType(
    'artifactVersion'
  )} of the asset`,
  returnType: inputs =>
    OpTypes.mappableNullable(inputs.asset.type, t => 'artifactVersion'),
  resolver: inputs => {
    const ret = OpTypes.mappableNullableVal(inputs.asset, asset => {
      const tag = OpTypes.getActualNamedTagFromValue(asset, 'file');
      const file = tag.file;
      if (file == null) {
        throw new Error('invalid');
      }
      return {id: file?.artifact?.id};
    });
    return ret;
  },
});

// Keeping this restricted to types which are guaranteed to have a path
const mediaAssetArgTypes = {
  asset: Types.nullableOneOrMany(Types.union(Types.BasicMediaTypes)),
};

export const opAssetFile = Graph.makeOp({
  name: 'asset-file',
  argTypes: mediaAssetArgTypes,
  description: `Returns the ${Graph.docType('file')} of the asset`,
  argDescriptions: {
    asset: 'The asset',
  },
  returnValueDescription: `The ${Graph.docType('file')} of the asset`,
  returnType: inputs =>
    OpTypes.mappableNullableTaggable(inputs.asset.type, t => {
      return {type: 'file'};
    }),
  resolver: async (inputs, forwardGraph, forwardOp, context, engine) => {
    const assetNode = constNode<Types.Type>(
      forwardOp.outputNode.node.type as any,
      inputs.asset
    ) as Types.ConstNode<Types.Type>;
    const files = await OpTypes.mappableNullableTaggableValAsync(
      inputs.asset,
      async asset => {
        return (
          await engine().executeNodes(
            [
              Op.opArtifactVersionFile({
                artifactVersion: Op.opAssetArtifactVersion({asset: assetNode}),
                path: constString(asset.path),
              }),
            ],
            false
          )
        )[0];
      }
    );
    return files;
  },
});
